import { $ } from "@/common/Axios";

export default {
  /**
   * 学历退费单
   */
  tuitionPayment: {
    /*
     * 编辑付款单
     * id id (integer query required)
     * amount 金额 (number query )
     * accountType 退款账号类型 (string query required)
     * accountNick 退款账号昵称 (string query required)
     * account 账号 (string query required)
     * applyRemark 申请备注 (string query )
     */
    put: (p, c) => $.put("/api/fms/tuition/tuitionPayment", p, c),

    /*
     * 删除付款单
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/fms/tuition/tuitionPayment", p, c),
  },
  tuitionPayment_remark: {
    /*
     * 备注
     * id 退费id (integer query required)
     * payRemark 备注 (string query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/tuitionPayment/remark", p, c),
  },
  tuitionPayment_pay: {
    /*
     * 打款
     * id id (integer query required)
     * payAccount 打款账号 (string query required)
     * payRemark 备注 (string query )
     * needSceneInfo 是否需要转账场景信息（新商户必传；true=带，false=不带，不传默认带） (boolean query )
     */
    put: (p, c) => $.put("/api/fms/tuition/tuitionPayment/pay", p, c),
  },
  tuitionPayment_audit: {
    /*
     * 审核
     * id id (integer query required)
     * auditStatus 审核状态 (string query required)
     * remark 备注 (string query )
     * fee 应退金额 (number query )
     * confirmed 确认 (boolean query )
     */
    put: (p, c) => $.put("/api/fms/tuition/tuitionPayment/audit", p, c),
  },
  tuitionPayment_createRefundPayment: {
    /*
     * 创建退费付款单（退学审核通过后调用）
     * schoolRollId 学籍id (integer query required)
     * changeId 异动id (integer query required)
     * accountType 退款账号类型 (string query required)
     * accountNick 退款账号昵称 (string query required)
     * account 退款账号 (string query required)
     * amount 退款金额 (number query required)
     * remark 备注 (string query )
     */
    post: (p, c) =>
      $.post("/api/fms/tuition/tuitionPayment/createRefundPayment", p, c),
  },
  tuitionPayment_listRefund: {
    /*
     * 退费付款单列表
     */
    get: (p, c) => $.get("/api/fms/tuition/tuitionPayment/listRefund", p, c),
  },
  tuitionPayment_listRefundBySchoolRollId: {
    /*
     * 根据合同id获取退费付款单详情
     * schoolRollId 合同id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/tuitionPayment/listRefundBySchoolRollId", p, c),
  },
  tuitionPayment_getByChangeId: {
    /*
     * 根据异动单id获取退费付款单详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/tuitionPayment/getByChangeId", p, c),
  },
  tuitionPayment_exportRefund: {
    /*
     * 导出退费付款单
     */
    get: (p, c) => $.get("/api/fms/tuition/tuitionPayment/exportRefund", p, c),
  },
  tuitionPayment_detailsRefund: {
    /*
     * 退费付款单详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/tuitionPayment/detailsRefund", p, c),
  },

  /**
   * 学历退费订单
   */
  tuitionPaymentOrder_remark: {
    /*
     * 备注
     * id 退费订单id (integer query required)
     * payRemark 备注 (string query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/tuitionPaymentOrder/remark", p, c),
  },
  tuitionPaymentOrder_pay: {
    /*
     * 打款
     * id 退费订单id (integer query required)
     * orderNo 订单号 (string query required)
     * payAccount 打款账号 (string query required)
     * auditRemark 备注 (string query required)
     * needSceneInfo 是否需要转账场景信息（新商户必传；true=带，false=不带，不传默认带） (boolean query )
     */
    put: (p, c) => $.put("/api/fms/tuition/tuitionPaymentOrder/pay", p, c),
  },
  tuitionPaymentOrder_audit: {
    /*
     * 审核
     * id 退费订单id (integer query required)
     * orderNo 订单号 (string query required)
     * auditStatus 审核状态：通过，拒绝 (string query required)
     * remark 备注 (string query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/tuitionPaymentOrder/audit", p, c),
  },
  tuitionPaymentOrder_restore: {
    /*
     * 修复
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/fms/tuition/tuitionPaymentOrder/restore", p, c),
  },
  tuitionPaymentOrder_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/fms/tuition/tuitionPaymentOrder/list", p, c),
  },
  tuitionPaymentOrder_listForStudentFees: {
    /*
     * 学生缴费单列表
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/tuitionPaymentOrder/listForStudentFees", p, c),
  },
  tuitionPaymentOrder_listForNight: {
    /*
     * 列表
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/tuitionPaymentOrder/listForNight", p, c),
  },
  tuitionPaymentOrder_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/fms/tuition/tuitionPaymentOrder/export", p, c),
  },
  tuitionPaymentOrder_exportForStudentFees: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/tuitionPaymentOrder/exportForStudentFees", p, c),
  },
  tuitionPaymentOrder_exportForNight: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/tuitionPaymentOrder/exportForNight", p, c),
  },
  tuitionPaymentOrder_downloadRestoreModule: {
    /*
     * 下载修复模版
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/tuitionPaymentOrder/downloadRestoreModule", p, c),
  },
  tuitionPaymentOrder_details: {
    /*
     * 详情
     * id 退费订单id (integer query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/tuitionPaymentOrder/details", p, c),
  },
  tuitionPaymentOrder_detailsForStudentFees: {
    /*
     * 详情
     * id 退费订单id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/tuitionPaymentOrder/detailsForStudentFees", p, c),
  },
  tuitionPaymentOrder_detailsForNight: {
    /*
     * 详情
     * id 退费订单id (integer query required)
     * studentId 学生id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/tuitionPaymentOrder/detailsForNight", p, c),
  },

  /**
   * 学费信息
   */
  tuition_updateTuitionInfoByBatchTransaction: {
    /*
     * 批量异动该学费
     * schoolRollId 合同id (integer query required)
     * periods 缴费次数 (integer query required)
     * beforeTutorFee 考前辅导费 (number query required)
     * firstTutorFee 第一次辅导费 (number query required)
     * firstFee 第一次学费 (number query required)
     * secondTutorFee 第二次辅导费 (number query required)
     * secondFee 第二次学费 (number query required)
     * thirdTutorFee 第三次辅导费 (number query required)
     * thirdFee 第三次学费 (number query required)
     * onceDiscountType 一次性优惠类型 (string query )
     * onceDiscountAmount 一次性缴费优惠金额 (number query required)
     * firstDiscountType 第一次优惠类型 (string query )
     * firstDiscountAmount 第一次优惠金额 (number query required)
     * secondDiscountType 第二次优惠类型 (string query )
     * secondDiscountAmount 第二次优惠金额 (number query required)
     * thirdDiscountType 第三次优惠类型 (string query )
     * thirdDiscountAmount 第三次优惠金额 (number query required)
     */
    put: (p, c) =>
      $.put(
        "/api/fms/tuition/tuition/updateTuitionInfoByBatchTransaction",
        p,
        c
      ),
  },
  tuition_uploadSettleAccount: {
    /*
     * 导入结算方
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/fms/tuition/tuition/uploadSettleAccount", p, c),
  },
  tuition_list: {
    /*
     * 学费列表
     */
    get: (p, c) => $.get("/api/fms/tuition/tuition/list", p, c),
  },
  tuition_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/fms/tuition/tuition/export", p, c),
  },
  tuition_exportForBigData: {
    /*
     * 大数据导出
     */
    get: (p, c) => $.get("/api/fms/tuition/tuition/exportForBigData", p, c),
  },

  /**
   * 返款计划
   */
  refundPlan: {
    /*
     * 修改
     * plan  ( query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/refundPlan", p, c),

    /*
     * 添加
     * plan  ( query required)
     */
    post: (p, c) => $.post("/api/fms/tuition/refundPlan", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/fms/tuition/refundPlan", p, c),
  },
  refundPlan_syncStudent: {
    /*
     * 同步学生
     * id id (integer query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/refundPlan/syncStudent", p, c),
  },
  refundPlan_remark: {
    /*
     * 备注
     * id id (integer query required)
     * remark 备注 (string query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/refundPlan/remark", p, c),
  },
  refundPlan_refund: {
    /*
     * 返款
     * id id (integer query required)
     * refundTime 返款时间 (string query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/refundPlan/refund", p, c),
  },
  refundPlan_upload: {
    /*
     * 导入
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/fms/tuition/refundPlan/upload", p, c),
  },
  refundPlan_uploadStudent: {
    /*
     * 导入学生
     * id id (integer query required)
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/fms/tuition/refundPlan/uploadStudent", p, c),
  },
  refundPlan_addStudent: {
    /*
     * 添加学生
     * id id (integer query required)
     * schoolRollIds 学生id (array query required)
     */
    post: (p, c) => $.post("/api/fms/tuition/refundPlan/addStudent", p, c),
  },
  refundPlan_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/fms/tuition/refundPlan/list", p, c),
  },
  refundPlan_listSubPlan: {
    /*
     * 子计划列表
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/refundPlan/listSubPlan", p, c),
  },
  refundPlan_listStudent: {
    /*
     * 学生列表
     * id id (integer query required)
     * name 学生姓名 (string query )
     */
    get: (p, c) => $.get("/api/fms/tuition/refundPlan/listStudent", p, c),
  },
  refundPlan_listForOut: {
    /*
     * 未纳入返款计划
     * siteType 学校类型 (string query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/refundPlan/listForOut", p, c),
  },
  refundPlan_listForMonth: {
    /*
     * 月返款计划列表
     * timeType 时间类型：上月，当月，下月 (string query required)
     * siteType 学校类型 (string query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/refundPlan/listForMonth", p, c),
  },
  refundPlan_listForLate: {
    /*
     * 逾期返款计划列表
     * siteType 学校类型 (string query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/refundPlan/listForLate", p, c),
  },
  refundPlan_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/fms/tuition/refundPlan/export", p, c),
  },
  refundPlan_exportStudent: {
    /*
     * 导出学生列表
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/refundPlan/exportStudent", p, c),
  },
  refundPlan_exportForOut: {
    /*
     * 未纳入返款计划导出
     * siteType 学校类型 (string query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/refundPlan/exportForOut", p, c),
  },
  refundPlan_exportForMonth: {
    /*
     * 月返款计划列表导出
     * timeType 时间类型：上月，当月，下月 (string query required)
     * siteType 学校类型 (string query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/refundPlan/exportForMonth", p, c),
  },
  refundPlan_exportForLate: {
    /*
     * 逾期返款计划列表导出
     * siteType 学校类型 (string query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/refundPlan/exportForLate", p, c),
  },
  refundPlan_deleteStudent: {
    /*
     * 删除学生
     * id id (integer query required)
     * schoolRollIds 学生id (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/fms/tuition/refundPlan/deleteStudent", p, c),
  },

  /**
   * 上交高校
   */
  handSchool: {
    /*
     * 编辑上交高校
     * handSchool  ( query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/handSchool", p, c),

    /*
     * 删除上交高校（表示不用上交了）
     * id 上交高校id (integer query required)
     */
    delete: (p, c) => $.delete("/api/fms/tuition/handSchool", p, c),
  },
  handSchool_receipt: {
    /*
     * 上传发票
     * id 上交高校id (integer query required)
     * receipt 发票 (string query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/handSchool/receipt", p, c),
  },
  handSchool_handRemark: {
    /*
     * 上交备注
     * id 上交高校id (integer query required)
     * handRemark 上交备注 (string query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/handSchool/handRemark", p, c),
  },
  handSchool_confirm: {
    /*
     * 确认
     * ids 上交高校ids (array query required)
     * confirmStatus 确认状态：确认上交，确认不上交 (string query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/handSchool/confirm", p, c),
  },
  handSchool_changeHandId: {
    /*
     * 修改上交人
     * ids 上交高校id (array query required)
     * handId 上交人id (integer query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/handSchool/changeHandId", p, c),
  },
  handSchool_batchUpdateNoHandStatus: {
    /*
     * 批量更新未上交状态
     * site 学校名称 (string query required)
     */
    put: (p, c) =>
      $.put("/api/fms/tuition/handSchool/batchUpdateNoHandStatus", p, c),
  },
  handSchool_upload: {
    /*
     * 导入
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/fms/tuition/handSchool/upload", p, c),
  },
  handSchool_remindReminder: {
    /*
     * 缴费提醒
     * searchText 查询字段 (string query required)
     * text 提醒内容 (string query required)
     */
    post: (p, c) => $.post("/api/fms/tuition/handSchool/remindReminder", p, c),
  },
  handSchool_remindConfirm: {
    /*
     * 确认提醒
     * searchText 查询字段 (string query required)
     * text 提醒内容 (string query required)
     */
    post: (p, c) => $.post("/api/fms/tuition/handSchool/remindConfirm", p, c),
  },
  handSchool_init: {
    /*
     * 初始化上交高校数据
     * siteType 学校类型：成教,远程,国开 (string query required)
     * rollGrade 学籍年级 (string query required)
     * feeType 缴费类型：第一次缴费,第二次缴费，第三次缴费 (string query required)
     */
    post: (p, c) => $.post("/api/fms/tuition/handSchool/init", p, c),
  },
  handSchool_initOne: {
    /*
     * 单个初始化上交高校数据
     * schoolRollId 合同编号 (integer query required)
     * feeType 缴费类型：第一次缴费,第二次缴费，第三次缴费 (string query required)
     */
    post: (p, c) => $.post("/api/fms/tuition/handSchool/initOne", p, c),
  },
  handSchool_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/fms/tuition/handSchool/list", p, c),
  },
  handSchool_listSimple: {
    /*
     * 简易上交高校列表
     * schoolRollId 学籍id (integer query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/handSchool/listSimple", p, c),
  },
  handSchool_listForService: {
    /*
     * 上交高校服务列表
     */
    get: (p, c) => $.get("/api/fms/tuition/handSchool/listForService", p, c),
  },
  handSchool_listForPayment: {
    /*
     * 简易上交高校列表
     * schoolRollId 学籍id (integer query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/handSchool/listForPayment", p, c),
  },
  handSchool_listForEducation: {
    /*
     * 上交高校教务列表
     */
    get: (p, c) => $.get("/api/fms/tuition/handSchool/listForEducation", p, c),
  },
  handSchool_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/fms/tuition/handSchool/export", p, c),
  },
  handSchool_exportForService: {
    /*
     * 服务导出
     */
    get: (p, c) => $.get("/api/fms/tuition/handSchool/exportForService", p, c),
  },
  handSchool_exportForSearchText: {
    /*
     * 根据查询字段导出
     * searchText 查询字段 (string query required)
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSchool/exportForSearchText", p, c),
  },
  handSchool_exportForEducation: {
    /*
     * 教务导出
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSchool/exportForEducation", p, c),
  },

  /**
   * 钉钉上交高校
   */
  handSchoolDingtalk_pay: {
    /*
     * 单个打款
     * id id (integer query required)
     * handAmount 实际上交金额，默认从应交中取 (number query required)
     * handTime 付款日期，默认当前 (string query required)
     * handAccount 付款账户 (string query required)
     * screenshots 截图 (string query )
     */
    put: (p, c) => $.put("/api/fms/tuition/handSchoolDingtalk/pay", p, c),
  },
  handSchoolDingtalk_mark: {
    /*
     * 标记|取消标记
     * id id (integer query required)
     * type 类型：标记，取消标记 (string query required)
     * remark 备注 (string query )
     */
    put: (p, c) => $.put("/api/fms/tuition/handSchoolDingtalk/mark", p, c),
  },
  handSchoolDingtalk_batchUpdatePassTime: {
    /*
     * 批量修改审核通过时间
     * dingtalkNo 钉钉审批号 (string query required)
     * passTime 付款日期，默认当前 (string query required)
     */
    put: (p, c) =>
      $.put("/api/fms/tuition/handSchoolDingtalk/batchUpdatePassTime", p, c),
  },
  handSchoolDingtalk_batchPay: {
    /*
     * 批量打款
     * dingtalkNo 钉钉审批号 (string query required)
     * handTime 付款日期，默认当前 (string query required)
     * handAccount 付款账户 (string query required)
     */
    put: (p, c) => $.put("/api/fms/tuition/handSchoolDingtalk/batchPay", p, c),
  },
  handSchoolDingtalk: {
    /*
     * 添加
     * handSchoolDingtalk  ( query required)
     */
    post: (p, c) => $.post("/api/fms/tuition/handSchoolDingtalk", p, c),

    /*
     * 删除
     * id 钉钉上交高校id (integer query required)
     */
    delete: (p, c) => $.delete("/api/fms/tuition/handSchoolDingtalk", p, c),
  },
  handSchoolDingtalk_upload: {
    /*
     * 导入
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/fms/tuition/handSchoolDingtalk/upload", p, c),
  },
  handSchoolDingtalk_uploadPay: {
    /*
     * 批量导入打款
     * handTime 付款日期，默认当前 (string query required)
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/fms/tuition/handSchoolDingtalk/uploadPay", p, c),
  },
  handSchoolDingtalk_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/fms/tuition/handSchoolDingtalk/list", p, c),
  },
  handSchoolDingtalk_getDefaultHandAccount: {
    /*
     * 获取默认的付款账户
     * dingtalkNo 钉钉审批号 (string query required)
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSchoolDingtalk/getDefaultHandAccount", p, c),
  },
  handSchoolDingtalk_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/fms/tuition/handSchoolDingtalk/export", p, c),
  },
  handSchoolDingtalk_amount: {
    /*
     * 金额
     */
    get: (p, c) => $.get("/api/fms/tuition/handSchoolDingtalk/amount", p, c),
  },
  handSchoolDingtalk_batchRemove: {
    /*
     * 批量删除
     * ids 钉钉上交高校id (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/fms/tuition/handSchoolDingtalk/batchRemove", p, c),
  },

  /**
   * 学费收费配置
   */
  tuitionFeeConfig: {
    /*
     * 添加
     * config  ( query required)
     */
    post: (p, c) => $.post("/api/fms/tuition/tuitionFeeConfig", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/fms/tuition/tuitionFeeConfig", p, c),
  },
  tuitionFeeConfig_upload: {
    /*
     * 导入
     * file  (string body required)
     */
    post: (p, c) => $.post("/api/fms/tuition/tuitionFeeConfig/upload", p, c),
  },
  tuitionFeeConfig_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/fms/tuition/tuitionFeeConfig/list", p, c),
  },
  tuitionFeeConfig_listSite: {
    /*
     * 学校列表
     */
    get: (p, c) => $.get("/api/fms/tuition/tuitionFeeConfig/listSite", p, c),
  },
  tuitionFeeConfig_getBySite: {
    /*
     * 根据学校获取缴费信息
     * site 学校 (string query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/tuitionFeeConfig/getBySite", p, c),
  },
  tuitionFeeConfig_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/fms/tuition/tuitionFeeConfig/export", p, c),
  },

  /**
   * 下级返款标准
   */
  rebateStandard: {
    /*
     * 添加
     * standard  ( query required)
     */
    post: (p, c) => $.post("/api/fms/tuition/rebateStandard", p, c),
  },
  rebateStandard_upload: {
    /*
     * 导入
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/fms/tuition/rebateStandard/upload", p, c),
  },
  rebateStandard_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/fms/tuition/rebateStandard/list", p, c),
  },
  rebateStandard_listForEducation: {
    /*
     * 成教列表
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/rebateStandard/listForEducation", p, c),
  },
  rebateStandard_listForContinue: {
    /*
     * 继教院列表
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/rebateStandard/listForContinue", p, c),
  },
  rebateStandard_export: {
    /*
     * 批量导出
     */
    get: (p, c) => $.get("/api/fms/tuition/rebateStandard/export", p, c),
  },
  rebateStandard_exportForEducation: {
    /*
     * 成教导出
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/rebateStandard/exportForEducation", p, c),
  },
  rebateStandard_exportForContinue: {
    /*
     * 继教院导出
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/rebateStandard/exportForContinue", p, c),
  },

  /**
   * 学费上交及结算标准
   */
  handSettlementStandard: {
    /*
     * 添加
     * standard  ( query required)
     */
    post: (p, c) => $.post("/api/fms/tuition/handSettlementStandard", p, c),
  },
  handSettlementStandard_upload: {
    /*
     * 导入
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/fms/tuition/handSettlementStandard/upload", p, c),
  },
  handSettlementStandard_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/fms/tuition/handSettlementStandard/list", p, c),
  },
  handSettlementStandard_listForSkillTrain: {
    /*
     * 技能培训列表
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSettlementStandard/listForSkillTrain", p, c),
  },
  handSettlementStandard_listForSelf: {
    /*
     * 自考列表
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSettlementStandard/listForSelf", p, c),
  },
  handSettlementStandard_listForGeo: {
    /*
     * GEO平台列表
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSettlementStandard/listForGeo", p, c),
  },
  handSettlementStandard_listForExemptionDegree: {
    /*
     * 免试专升本列表
     */
    get: (p, c) =>
      $.get(
        "/api/fms/tuition/handSettlementStandard/listForExemptionDegree",
        p,
        c
      ),
  },
  handSettlementStandard_listForEducation: {
    /*
     * 成教列表
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSettlementStandard/listForEducation", p, c),
  },
  handSettlementStandard_listForContinue: {
    /*
     * 继教院列表
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSettlementStandard/listForContinue", p, c),
  },
  handSettlementStandard_listForArmySkill: {
    /*
     * 退伍军人技能培训列表
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSettlementStandard/listForArmySkill", p, c),
  },
  handSettlementStandard_listForAigc: {
    /*
     * AIGC平台列表
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSettlementStandard/listForAigc", p, c),
  },
  handSettlementStandard_export: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSettlementStandard/export", p, c),
  },
  handSettlementStandard_exportForSkillTrain: {
    /*
     * 技能培训导出
     */
    get: (p, c) =>
      $.get(
        "/api/fms/tuition/handSettlementStandard/exportForSkillTrain",
        p,
        c
      ),
  },
  handSettlementStandard_exportForSelf: {
    /*
     * 自考导出
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSettlementStandard/exportForSelf", p, c),
  },
  handSettlementStandard_exportForGeo: {
    /*
     * GEO平台导出
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSettlementStandard/exportForGeo", p, c),
  },
  handSettlementStandard_exportForExemptionDegree: {
    /*
     * 免试专升本导出
     */
    get: (p, c) =>
      $.get(
        "/api/fms/tuition/handSettlementStandard/exportForExemptionDegree",
        p,
        c
      ),
  },
  handSettlementStandard_exportForEducation: {
    /*
     * 成教导出
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSettlementStandard/exportForEducation", p, c),
  },
  handSettlementStandard_exportForContinue: {
    /*
     * 继教院导出
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSettlementStandard/exportForContinue", p, c),
  },
  handSettlementStandard_exportForArmySkill: {
    /*
     * 退伍军人技能培训导出
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSettlementStandard/exportForArmySkill", p, c),
  },
  handSettlementStandard_exportForAigc: {
    /*
     * AIGC平台导出
     */
    get: (p, c) =>
      $.get("/api/fms/tuition/handSettlementStandard/exportForAigc", p, c),
  },

  /**
   * 上交高校信息
   */
  handSchoolInfo_view: {
    /*
     * 上交高校视图
     * siteType 学校类型 (string query required)
     * batch 批次 (string query required)
     * feeType 缴费类型：第一次缴费,第二次缴费，第三次缴费 (string query required)
     * schoolStatuses 学籍状态 (array query required)
     */
    get: (p, c) => $.get("/api/fms/tuition/handSchoolInfo/view", p, c),
  },
};
